import axios from "axios"
import type { InternalAxiosRequestConfig } from "axios"
import { apiUrl } from "mco-typescript-core/src/url/host"
import { tenantRegistry } from "mco-tenant-configurations"
import { getCredentialFromStorage } from "../../../components/authentication/AuthenticationStorage"
import { getTenantSubDomain } from "../../../components/tenancy/TenantHooks"

type AxiosInterceptor = (
	config: InternalAxiosRequestConfig<any>
) => Promise<any>

export const createOverriddenDateInterceptor =
	(overriddenDateProvider: () => string | undefined): AxiosInterceptor =>
	async (request) => {
		const overriddenDate = overriddenDateProvider()

		if (!overriddenDate) {
			return request
		}

		request.headers = request.headers.set(
			"mco-overridden-date",
			overriddenDate
		)
		return request
	}

const createAuthTokenInterceptor = (): AxiosInterceptor => async (request) => {
	const credential = getCredentialFromStorage()

	if (!credential) {
		return request
	}

	request.headers = request.headers.set(
		"Authorization",
		`Bearer ${credential.access_token}`
	)

	return request
}

const createTenantInterceptor = (): AxiosInterceptor => async (request) => {
	const tenantSubDomain = getTenantSubDomain(window.location.pathname)
	if (!tenantSubDomain || !tenantRegistry.isSubDomain(tenantSubDomain)) {
		return request
	}

	request.headers = request.headers.set(
		"mco-tenant-subdomain",
		tenantSubDomain
	)

	return request
}

const createAxiosClient = (base: string = apiUrl) => {
	const axiosClient = axios.create({
		baseURL: base,
		withCredentials: true
	})

	axiosClient.interceptors.request.use(createAuthTokenInterceptor())
	axiosClient.interceptors.request.use(createTenantInterceptor())

	return axiosClient
}

export default createAxiosClient
